import FilterBindings from '../../common/modules/form-search/FilterBindings.js';
import MapFilters from '../../common/modules/MapClasses/MapFilters';
import Map from '../../common/modules/MapClasses/Map';
import Helpers from '../../common/modules/helpers/helpers';

export default class Catalog {
    constructor() {
        let $productListPage = $('.product-list-page');
        this.productListPageLength = $productListPage.length;
        this.filter = new FilterBindings();

        if (this.productListPageLength > 0) {
            this.filterAjaxRequest();
            this.sortingAjaxRequest();
            this.paginationAjaxRequest();

            let data = {
                'category_id': $productListPage.attr('data-category-id'),
                'response_type': 'id_list'
            };
            $(document).ready(function () {
                $.request('ProductList::onAjaxRequest', {
                    data: data,
                    complete: (response) => {

                        data = response.responseJSON;
                        MapFilters.setProductIDList(data.list);
                        MapFilters.filter();
                    }
                });

                $.request('MapHelper::onGetProductListData', {
                    data: data,
                    complete: (response) => {

                        data = response.responseJSON;
                        Map.mapItemsData = data;
                        MapFilters.filter();
                    }
                });
            });
        }
    }

    filterAjaxRequest() {
        window.filterShopaholicAjaxRequest = () => {
            let $countOutput = $('._js-filter-count'),
                data = {
                    'category_id': $('.product-list-page').attr('data-category-id'),
                    'response_type': 'id_list'
                };

            $countOutput.hide();
            this.filter.updateFilters();

            $.request('ProductList::onAjaxRequest', {
                data: data,
                loading: '.js-preloaderOverlay',
                update: {
                    'product_list': '.product-list-page',
                    'catalog_pagination_button': '.oc-shopaholic-pagination',
                    'catalog_product_count': '.filter__count-of-product._js-filter-count'
                },
                complete: (response) => {
                    data = response.responseJSON;
                    if (!Helpers.isMobile()) {
                        $countOutput.show();
                    } else {
                        //append filtered products amount
                        let productCount = $('._js-filter-count').find('span').attr('data-product-count');
                        $('._js-mobile-filter-count').text(` (${productCount})`);
                    }
                    MapFilters.setProductIDList(data.list);
                    MapFilters.filter();
                }
            });
        };
    }

    sortingAjaxRequest() {
        window.sortingShopaholicAjaxRequest = () => {
            $.request('ProductList::onAjaxRequest', {
                data: {'show_all': true},
                loading: '.js-preloaderOverlay',
                update: {
                    'product_list': '.product-list-page',
                    'catalog_pagination_button': '.oc-shopaholic-pagination'
                }
            });
        };
    }

    paginationAjaxRequest() {
        window.paginationShopaholicAjaxRequest = () => {
            $.request('ProductList::onAjaxRequest', {
                loading: '.js-preloaderOverlay',
                update: {
                    'product_list': '@.product-list-page',
                    'catalog_pagination_button': '.oc-shopaholic-pagination'
                },
                complete: function () {
                    $('.seo-content').remove();
                }
            });
        };
    }
}


// WEBPACK FOOTER //
// ./src/pages/catalog/Catalog.js